const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },

      {
        component: "search-check-group",
        label: "",
        value: "half",
        query: { ck_l: "checkList" },
        options: {
          list: [
            { text: "상반기", value: "상반기" },
            { text: "하반기", value: "하반기" },
          ],
          selectMaxCount: 1,
          default: [],
        },
      },
      {
        component: "search-start-end",
        label: "점검일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "점검일", "작성일", "점검결과(이행)", "점검결과(보완필요)", "반기", "연도"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    // 상반기 / 하반기
    if (search.half && search.half.length > 0) {
      conditions.push({ key: "header.half", operator: "=", value: search.half });
    }

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.점검일", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.점검일", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "연도",
        key: "header.year",
      },
      {
        name: "반기",
        key: "header.half",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "점검일",
        key: "body.점검일",
      },
      {
        name: "점검결과(이행)",
        key: "body.이행총계",
      },
      {
        name: "점검결과(보완필요)",
        key: "body.보완필요총계",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const header = JSON.parse(value.post_content).header;
      switch (index) {
        case 0:
          return header.year; // 연도
        case 1:
          return header.half; // 반기
        case 2:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 3:
          return func.getContent(value).점검일; // 점검일
        case 4:
          return func.getContent(value).이행총계; // 점검결과(이행)
        case 5:
          return func.getContent(value).보완필요총계 || '0'; // 점검결과(보완필요)
        case 6:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 7:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
